export const fmtMoney = (amount, currency = "INR") => {
    try {
        return new Intl.NumberFormat("en-IN", { style: "currency", currency, maximumFractionDigits: 0 }).format(amount || 0);
    } catch {
        return `${currency} ${amount || 0}`;
    }
};

export const MONTH_LABEL = (m) => {
    if (!m) return "";
    const [y, mo] = m.split("-");
    return new Date(Number(y), Number(mo) - 1).toLocaleString("en-IN", { month: "long", year: "numeric" });
};

const STATUS_STYLES = {
    paid: "bg-teal-soft text-teal",
    pending: "bg-amber-100 text-amber-700",
    overdue: "bg-red-100 text-red-700",
    failed: "bg-red-100 text-red-700",
    partially_paid: "bg-blue-100 text-blue-700",
    refunded: "bg-slate-200 text-slate-600",
    new: "bg-saffron-soft text-saffron-dark",
    contacted: "bg-blue-100 text-blue-700",
    trial_scheduled: "bg-violet-100 text-violet-700",
    trial_completed: "bg-teal-soft text-teal",
    enrolled: "bg-teal text-cream",
    not_interested: "bg-slate-200 text-slate-600",
    active: "bg-teal-soft text-teal",
    paused: "bg-amber-100 text-amber-700",
    completed: "bg-blue-100 text-blue-700",
    inactive: "bg-slate-200 text-slate-600",
    scheduled: "bg-blue-100 text-blue-700",
    cancelled: "bg-red-100 text-red-700",
};

export const STATUS_LABELS = {
    partially_paid: "Partially Paid",
    not_interested: "Not Interested",
    trial_scheduled: "Trial Scheduled",
    trial_completed: "Trial Completed",
};

export const Badge = ({ value }) => (
    <span
        data-testid={`status-badge-${value}`}
        className={`inline-block rounded-full px-3 py-1 text-xs font-medium ${STATUS_STYLES[value] || "bg-slate-100 text-slate-600"}`}
    >
        {STATUS_LABELS[value] || (value || "").replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase())}
    </span>
);

export const StatCard = ({ icon: Icon, label, value, sub, tone = "teal", testid }) => (
    <div className="rounded-2xl border border-border bg-white p-6 card-shadow" data-testid={testid}>
        <div className="flex items-center justify-between">
            <p className="text-xs font-medium uppercase tracking-[0.16em] text-muted-foreground">{label}</p>
            <span className={`grid h-10 w-10 place-items-center rounded-xl ${tone === "saffron" ? "bg-saffron-soft text-saffron-dark" : "bg-teal-soft text-teal"}`}>
                <Icon className="h-5 w-5" />
            </span>
        </div>
        <div className="mt-3 font-serif text-3xl font-semibold text-ink">{value}</div>
        {sub && <p className="mt-1 text-xs text-muted-foreground">{sub}</p>}
    </div>
);

export const EmptyState = ({ message }) => (
    <div className="rounded-2xl border border-dashed border-border bg-white p-12 text-center text-sm text-muted-foreground" data-testid="empty-state">
        {message}
    </div>
);

export const inputCls = "bg-white rounded-lg border-border focus-visible:ring-saffron";

export const ENQUIRY_STATUSES = ["new", "contacted", "trial_scheduled", "trial_completed", "enrolled", "not_interested"];
export const CURRENCIES = ["INR", "USD", "EUR", "GBP", "AUD", "CAD"];
export const SUBJECT_OPTIONS = ["Hindi", "English", "Maths", "Science", "Coding"];
export const STUDENT_STATUSES = ["active", "paused", "completed", "inactive"];
